const filters = {
    currency_na(value) {
        if(value == 0) return "N/A";
        return numeral(value).format('$0,0');
    },

    currency_2dec(value) {
        if(value == 0) return "N/A";
        return numeral(value).format('$0,0.00');
    },

    number_na(value) {
        if(value == 0) return "N/A";
        return numeral(value).format('0,0');
    },

    percentage_na(value) {
        if(value == 0) return "N/A";
        var flt = parseFloat(value);
        if (flt < 0.01 && flt > -0.01) {
            if (flt == 0.00) {
                return numeral(value).format('0%');
            }
            return numeral(value).format('0.00%');
        }
        return numeral(value).format('0,0.0%');
    },

    currency(value) {
        if(value == 0) return "";
        return numeral(value).format('$0,0');
    },

    number(value) {
        if(value == 0) return "";
        return numeral(value).format('0,0');
    },

    currency_with_zero(value) {
        return numeral(value).format('$0,0');
    },

    number_with_zero(value) {
        return numeral(value).format('0,0');
    },

    number_with_decimal(value) {
        var flt = parseFloat(value);
        if (flt < 10 && flt > -10) {
            if (flt == 0.00) {
                return numeral(value).format('0');
            }
            return numeral(value).format('0.0');
        }
        return numeral(value).format('0,0');
    },

    currency_with_decimal(value) {
        var flt = parseFloat(value);
        if (flt < 10 && flt > -10) {
            if (flt == 0.00) {
                return numeral(value).format('$0');
            }
            return numeral(value).format('$0.00');
        }
        return numeral(value).format('$0,0.00');
    },

    percentage(value) {
        var flt = parseFloat(value);
        if (flt < 0.01 && flt > -0.01) {
            if (flt == 0.00) {
                return numeral(value).format('0%');
            }
            return numeral(value).format('0.00%');
        }
        return numeral(value).format('0,0.0%');
    },

    propercase(value) {
        if(value == undefined) return "";
        value = String(value).replaceAll("_", " ");
        return value.replace(
            /\w\S*/g,
            function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
    },

    date(value) {
        if (value) {
            return moment(String(value)).local().format('M/D/YYYY');
        }
    },

    date_utc(value) {
        if (value) {
            return moment(String(value)).utc().format('M/D/YYYY');
        }
    },

    month(value) {
        if (value) {
            return moment(String(value)).utc().format('M/YYYY')
        }
    },

    datetime(value) {
        if (value) {
            return moment(String(value)).local().format('M/D/YYYY h:mm a');
        }
    },

    full_datetime(value) {
        if (value) {
            return moment(String(value)).local().format('MMMM D, YYYY') + " at " + moment(String(value)).local().format('h:mm a');
        }
    },

    date_name(value) {
        if (value) {
            return moment(String(value)).utc().format('MMMM YYYY')
        }
    },

    full_date_name(value) {
        if (value) {
            return moment(String(value)).utc().format('MMMM D, YYYY')
        }
    },

    num_abbr(number) {
        const shortsymbols = {
            4: 'T', //trillionths
            3: 'B', //billionths
            2: 'M', //millionths
            1: 'K' //thousanths
        }
        str_num = Math.round(number).toString()

        let commaCount = Math.floor((str_num.length-1) / 3)

        if(commaCount > 0){
            let symbol = shortsymbols[commaCount]
            let dotPlacement = str_num.length%3;
            if(dotPlacement === 0) dotPlacement = 3;
            str_num = str_num.substr(0,dotPlacement) + '.' + str_num.substr(dotPlacement)
            str_num = Math.round(Number(str_num) * 10)/10
            str_num += symbol
            return str_num;
        } else {
            var flt = parseFloat(number);
            if (flt < 10 && flt > -10) {
                if (flt == 0.00) {
                    return numeral(number).format('0');
                }
                return numeral(number).format('0.0');
            }
            return numeral(number).format('0,0');
        }
        return number;
    },

    num_abbr_wo_float(number) {
        const shortsymbols = {
            4: 'T', //trillionths
            3: 'B', //billionths
            2: 'M', //millionths
            1: 'K' //thousanths
        }
        str_num = Math.round(number).toString()

        let commaCount = Math.floor((str_num.length-1) / 3)

        if(commaCount > 0){
            let symbol = shortsymbols[commaCount]
            let dotPlacement = str_num.length%3;
            if(dotPlacement === 0) dotPlacement = 3;
            str_num = str_num.substr(0,dotPlacement) + '.' + str_num.substr(dotPlacement)
            str_num = Math.round(Number(str_num) * 10)/10
            str_num += symbol
            return str_num;
        } else {
            var flt = parseFloat(number);
            if (flt < 10 && flt > -10) {
                return numeral(number).format('0');
            }
            return numeral(number).format('0,0');
        }
    },

    currency_abbr(number) {
        const shortsymbols = {
            4: 'T', //trillionths
            3: 'B', //billionths
            2: 'M', //millionths
            1: 'K' //thousanths
        }
        number = Math.round(number).toString()

        let commaCount = Math.floor((number.length-1) / 3)

        if(commaCount > 0){
            let symbol = shortsymbols[commaCount]
            let dotPlacement = number.length%3;
            if(dotPlacement === 0) dotPlacement = 3;
            number = number.substr(0,dotPlacement) + '.' + number.substr(dotPlacement)
            number = Math.round(Number(number) * 10)/10
            number += symbol
        }

        return "$" + number;
    },

    htmlify(value) {
        if(value == null) return "";
        return value.replace(/\n/g, "<br />");
    },

    fileSize(size) {
        if (isNaN(size) || size === null) return '--';
        const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
        const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const readableSize = (size / Math.pow(1024, i)).toFixed(1);
        return `${readableSize} ${units[i]}`;
    }
};

export default filters;
